import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import DurationService, { BasicDurations } from "app/services/DurationService";

import { categoryToIndustryKey } from "../../ads/industry/categoryToIndustryKey";
import { useDisplayAdvertiserPublisherDataAndParams } from "../../hooks/useDisplayAdvertiserPublisherDataAndParams";

// Shared by every industry-mode Display Advertising hook: resolves the current
// country/duration/category into the country/from/to/isWindow/industryKey (and,
// when the selected duration is a rolling window, `latest`) params every
// industry endpoint expects.
// No explicit return annotation — inferred so each field keeps the precise
// (non-widened) type the underlying endpoint params expect.
export const useIndustryQueryParams = (category: IFlattenedCategory) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    // `forAPI.iso` is yyyy-MM-dd, the canonical format the endpoint's from/to expect.
    const { iso, isWindow } = DurationService.getDurationData(
        params.duration ?? BasicDurations.LAST_TWENTY_EIGHT_DAYS,
    ).forAPI;
    const industryKey = categoryToIndustryKey(category);

    return {
        country: params.country,
        from: iso.from,
        to: iso.to,
        isWindow,
        industryKey,
        ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
    };
};
